import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { EnquiryForm } from "./EnquiryForm";

export const EnquiryDialog = ({ trigger, packageId = "", tripType = "", defaultMessage = "", title = "Get a free Andaman quote", idPrefix = "dialog-enquiry" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-xl max-h-[92vh] overflow-y-auto bg-white" data-testid="enquiry-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl text-navy">{title}</DialogTitle>
          <DialogDescription>Share a few details and our team will send you a personalised quote.</DialogDescription>
        </DialogHeader>
        {open && <EnquiryForm defaultPackageId={packageId} defaultTripType={tripType} defaultMessage={defaultMessage} idPrefix={idPrefix} />}
      </DialogContent>
    </Dialog>
  );
};
